export const getMaskedOrOriginal = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  isPHIMaskingEnabled: boolean | undefined,
  fallback = 'N/A'
): string => {
  const first = firstName?.trim() ?? '';
  const last = lastName?.trim() ?? '';
  if (!first && !last) {
    return fallback;
  }
  if (!isPHIMaskingEnabled) {
    return `${first} ${last}`.trim();
  }
  return `${first.slice(0, 1)} ${last.slice(0, 3)}`.trim();
};
